module.exports = __webpack_public_path__ + "static/media/needimg2.5d635f3d.jpg";